import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, Text, ResponsiveContainer } from 'recharts';
import { colors_reports } from '../../constants/colors_reports';

const dataKey = [
  "Concesionario",
  "Particular"
]

function ServicesByTypeClient({ data }) {

  return (
    <div className="mt-2">
      <Text x={300} y={30} fontSize={30} fontWeight="bold" textAnchor="middle">
        Servicios prestados por tipo de cliente
      </Text>
      <ResponsiveContainer width="95%" height={400} >
        <BarChart
          data={data}
          margin={{
            top: 7,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="10 7" />
          <XAxis dataKey="month">
            <Label value="MES" offset={-5} position="insideBottom" />
          </XAxis>
          <YAxis>
            <Label value='Numero de Servicios' offset={15} angle='-90' position="insideBottomLeft" />
          </YAxis>
          <Tooltip />
          <Legend verticalAlign="top" />
          {
            dataKey.map((element, i) => {
              return (
                <Bar key={i} dataKey={element} fill={colors_reports[i]} />
              )
            })
          }
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ServicesByTypeClient;